import { capitalCase, dotCase } from "change-case";
export default {
  data: () => ({
    permissionTypes: ["Create", "View", "Update", "Delete"],
    permissionSection: null,
  }),
  computed: {
    user_permissions() {
      return this.$store.getters.user_permissions;
    },
    permissionSections() {
      const routes = this.$router.options.routes || [];
      const dashboardLayout = routes.find((x) => x.name === "dashboardLayout");
      const _sections = (dashboardLayout.children || [])
        .filter((x) => x.meta && x.meta.group)
        .map((x) => capitalCase(x.name));
      ///for mobile permissions
      _sections.push("Assigned Exception");
      return _sections;
    },

    hasPermissionCreate() {
      return this.checkPermissionAction("create");
    },

    hasPermissionView() {
      const view = this.checkPermissionAction("view");
      return view;
    },

    hasPermissionUpdate() {
      return this.checkPermissionAction("update");
    },
    hasPermissionDisable() {
      return this.checkPermissionAction("disable");
    },
    hasPermissionRestore() {
      return this.checkPermissionAction("restore");
    },

    hasPermissionDelete() {
      return this.checkPermissionAction("delete");
    },
  },

  watch: {
    hasPermissionCreate: function (val) {
      this.$set(this.$userPermissions, "hasPermissionCreate", !!val);
    },
    hasPermissionDelete: function (val) {
      this.$set(this.$userPermissions, "hasPermissionDelete", !!val);
    },
    hasPermissionUpdate: function (val) {
      this.$set(this.$userPermissions, "hasPermissionUpdate", !!val);
    },
    hasPermissionView: function (val) {
      this.$set(this.$userPermissions, "hasPermissionView", !!val);
    },
  },

  created() {
    //set permission section to controller name
    const section = this.$options.name.split("-")[0];
    let permissionSection = capitalCase(section);
    this.permissionSection = permissionSection;
    this.$userPermissions = {};
  },
  mounted() {
    this.$set(
      this.$userPermissions,
      "hasPermissionCreate",
      this.hasPermissionCreate
    );
    this.$set(
      this.$userPermissions,
      "hasPermissionDelete",
      this.hasPermissionDelete
    );
    this.$set(
      this.$userPermissions,
      "hasPermissionUpdate",
      this.hasPermissionUpdate
    );
    this.$set(
      this.$userPermissions,
      "hasPermissionView",
      this.hasPermissionView
    );
  },

  methods: {
    getComponentPermissions() {
      const {
        hasPermissionCreate,
        hasPermissionDelete,
        hasPermissionUpdate,
        hasPermissionView,
      } = this;
      return {
        hasPermissionCreate,
        hasPermissionDelete,
        hasPermissionUpdate,
        hasPermissionView,
      };
    },
    setPermissionSection(section) {
      section = capitalCase(section);
      if (!this.permissionSections.includes(section))
        throw new Error("Illegal Permission Section");
      this.permissionSection = section;
    },

    checkPermissionAction(action, action_full = false) {
      // console.log('check------',action)
      // console.log('this.permissionSection',this.permissionSection)
      if (!this.permissionSection) return false;
      if (!this.permissionSections.includes(this.permissionSection)) {
        return false;
      }
      const section = dotCase(this.permissionSection);
      if (action_full) {
        return this.user_permissions.includes(`${action}`);
      }
      return this.user_permissions.includes(`${action}.${section}`);
    },
    isDeepEqual(obj1, obj2) {
      if (obj1 === obj2) {
        return true;
      }

      if (
        typeof obj1 !== "object" ||
        obj1 === null ||
        typeof obj2 !== "object" ||
        obj2 === null
      ) {
        return false;
      }

      const keys1 = Object.keys(obj1);
      const keys2 = Object.keys(obj2);

      if (keys1.length !== keys2.length) {
        return false;
      }

      for (let key of keys1) {
        if (!keys2.includes(key)) {
          return false;
        }

        if (typeof obj1[key] === "object" && typeof obj2[key] === "object") {
          if (!this.isDeepEqual(obj1[key], obj2[key])) {
            return false;
          }
        } else if (obj1[key] !== obj2[key]) {
          return false;
        }
      }

      return true;
    },
  },
};
